import React, { useEffect, useState } from 'react';
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridRow, GridCell } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import addIdToData from '../../utilities/addIdToData';
import { MDBBtn, MDBTextArea } from 'mdb-react-ui-kit';
import { extractFileNameAndExtension } from '../../utilities/extractFileNameAndExtension';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loader from '../Loader';
import API_BASE_URL from '../../utilities/apiConfig';
import voucherDateAndTimeFormatter from '../../utilities/voucherDateAndTimeFormatter';

export default function FeesDetailsTable({TableColumns,feesDetailsData, tableName, height = 450 }) {
   
   
    const [expandedRowId, setExpandedRowId] = useState(null);

    const [refresh, setRefresh] = useState(0);

   

    
    
      const formatRegData = voucherDateAndTimeFormatter(feesDetailsData, ['entryDate','registrationDate', 'requestedTimePreiodDate', 'appliedDate', 'dateOfBirth', 'mentorJoiningDate', 'retirementYear']);
      const DataWithId = addIdToData(formatRegData);
      
      const handleClick = (event, cellValues) => {
        console.log('button executed', cellValues);
      }
    
   
    

    const userData = useSelector(state => state.auth?.userData?.authUser);

    const handleRowClick = (rowdata) => {
        console.log(rowdata);
        setExpandedRowId(expandedRowId === rowdata?.id ? null : rowdata?.id);

       
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton
                    slotProps={{
                        tooltip: { title: 'Export data' },
                        button: { variant: 'outlined' },
                    }}
                />
                <GridToolbarFilterButton
                    slotProps={{
                        tooltip: { title: 'Export data' },
                        button: { variant: 'outlined' },
                    }}
                />
                <GridToolbarDensitySelector
                    slotProps={{
                        tooltip: { title: 'Export data' },
                        button: { variant: 'outlined' },
                    }}
                />
               
                <GridToolbarExport
                    slotProps={{
                        tooltip: { title: 'Export data' },
                        button: { variant: 'outlined' },
                    }}
                />
            </GridToolbarContainer>
        );
    }


    const columns = TableColumns.map((col) => {
        if (col.field === 'name') {
            return {
                ...col,
                renderCell: (params) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar sx={{ bgcolor: 'primary.main' }} src={`https://api.adorable.io/avatars/50/${params.value}.png`} style={{ marginRight: 8 }} />
                        {params.value}
                    </div>
                ),
            };
        }

        if (col.field === 'daysLeft') {
            return {
                ...col,
                renderCell: (params) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {/* <Avatar style={{ marginRight: 8 }} >{params.value}<Avatar/> */}
                        <Avatar
                            sx={{ bgcolor: params.value <= 0 ? 'success.main' : 'warning.main' }}
                            style={{ marginRight: 8 }}
                        >
                            {params.value <= 0 ? 0 : params.value}
                        </Avatar>

                    </div>
                ),
            };
        }
        return col;
    });

    const rows = DataWithId.map((row) => ({
        ...row,
        id: row.id || row.advocateBarId,
    }));
   

   


 

   


   

    return (
        <>
         
            <div className="row justify-content-center mb-4">
                <div className="col-xxl-9">
                    <div className='mt-5' style={{ height: height }}>
                        <h2 className="mb-3 text-center">{tableName}</h2>
                        <DataGrid
                            rows={rows}
                            columns={[
                                {
                                    field: 'expand',
                                    headerName: '',
                                    width: 50,
                                    filterable: false,
                                    sortable: false,
                                    hideable: false,

                                    renderCell: (params) => (
                                        <IconButton onClick={() => handleRowClick(params.row)}>
                                            {expandedRowId === params.row.id ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </IconButton>
                                    ),
                                },
                                ...columns,
                            ]}
                            slots={{
                                toolbar: CustomToolbar,
                            }}

                            components={{ Toolbar: CustomToolbar }}
                            disableRowSelectionOnClick
                            hideFooterPagination
                            getRowId={(row) => row.id}
                        />
                       
                    </div>
                </div>
            </div>
        </>
    );
}

